import { LoggingEvent, type LoggingEventProps } from './LoggingEvent';

type Props = Omit<LoggingEventProps, 'action' | 'targetEventName'>;

export const LoggingClick = (props: Props) => {
  return <LoggingEvent {...props} action="click" targetEventName="onClick" />;
};
